import { render, staticRenderFns } from "./uxUGCGameplayPanel.vue?vue&type=template&id=5d0646aa&scoped=true&"
import script from "./uxUGCGameplayPanel.vue?vue&type=script&lang=js&"
export * from "./uxUGCGameplayPanel.vue?vue&type=script&lang=js&"
import style0 from "./uxUGCGameplayPanel.vue?vue&type=style&index=0&id=5d0646aa&lang=less&scoped=true&"
import style1 from "./uxUGCGameplayPanel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0646aa",
  null
  
)

export default component.exports